import React from "react";
import Link from "components/elements/link";
import Svg from "components/elements/svg";

const Breadcrumbs = ({ children }: BreadcrumbsProps) => (
  <div className="breadcrumbs">
    <ul className="breadcrumbs__inner container">
      <li
        key="/index"
        className="breadcrumb"
        itemScope
        itemType="http://data-vocabulary.org/Breadcrumb"
      >
        {/* @ts-expect-error use next link */}
        <Link to="/" itemProp="url">
          <Svg src="breadcrumb-home" className="icon" />
          <span className="label" itemProp="title">
            Home
          </span>
        </Link>
      </li>
      {children}
    </ul>
  </div>
);

Breadcrumbs.Item = ({ url, title }: BreadcrumbsItemProps) => (
  <li
    className="breadcrumb"
    itemScope
    itemType="http://data-vocabulary.org/Breadcrumb"
  >
    {/* @ts-expect-error use next link */}
    <Link to={url} itemProp="url">
      <span className="label" itemProp="title">
        {title}
      </span>
    </Link>
  </li>
);

type BreadcrumbsItemProps = {
  url: string;
  title: string;
};

type BreadcrumbsProps = {
  children: React.ReactNode;
};

export default Breadcrumbs;
